import WelcomeTeamManager from '@/screens/WelcomeTeamManager';

export default function PrivateWelcomeTeamRoute() {
  return <WelcomeTeamManager />;
}
